export const showSnackbar = data => ({
  type: 'SHOW_SNACK_BAR',
  data,
});
export const fullKYC = payload => ({
  type: 'FULL_KYC',
  payload,
  loader: true,
});
export const minKYC = payload => ({
  type: 'MIN_KYC',
  payload,
  loader: true,
});

export const setMinKycDetails = data => ({
  type: 'SET_MIN_KYC_DETAILS',
  data,
});

export const getCityState = pin => ({
  type: 'KYC_PIN',
  pin,
  loader: true,
});

export const setCityState = data => ({
  type: 'ADDRESS_INFO',
  data,
});

export const saveKycAddress = (payload, method) => ({
  type: 'SAVE_ADDRESS',
  payload,
  method,
});

export const getVideoKycLink = payload => ({
  type: 'VIDEO_KYC',
  payload,
});

export const setVideoKycLink = link => ({
  type: 'VIDEO_KYC_LINK',
  link,
});

export const getDocType = payload => ({
  type: 'GET_DOC_TYPE',
  payload,
});

export const setKycDocType = data => ({
  type: 'SET_DOC_TYPE',
  data,
});
